import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import ErrorBoundary from './ErrorBoundary.jsx';
import './index.css';

// Register the service worker unconditionally (not just when a user opts into push
// notifications) — an active service worker is one of the browser's requirements for
// showing an "Install app" / "Add to Home Screen" prompt, alongside the manifest in
// index.html. subscribeToPush() later reuses this same registration rather than
// creating a second one.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((e) => console.error("Service worker registration failed:", e));
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
